/* -disable array-callback-return */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Pagination from '../../../../components/Pagination';

import {
  changeFilters,
  changeSearchFieldIsInUse,
  filtersClear,
  getNFList,
} from '../../../../redux/tracking';
import { getNFListUI } from '../../../../redux/selectors';

import NewTrackingNFItem from './NewTrackingNFItem';

import {
  ChipContainer,
  ClearSearchButton,
  EmptyStateContainer,
  NFList,
  SearchResultContainer,
  StyledButton,
  WarningImage,
  Wrapper,
} from './styles';
// import { getCustomerCompanyList } from '../../../../redux/tracking-manager';
import WarningSecondaryIcon from '../../../../assets/images/warning-secondary-icon.png';
import NotFoundIcon from '../../../../assets/images/not-found-icon.png';
import { Typography } from '@mui/material';
import { Replay } from '@mui/icons-material';
import ChipItem from '../Details/components/ChipItem';
import { FILTERS_NOT_USED_BY_THE_CHIP } from '../Details/components/ChipItem/enums';

class TrackingNFList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      paginationOptions: [
        {
          value: 10,
          label: '10',
        },
        {
          value: 25,
          label: '25',
        },
        {
          value: 50,
          label: '50',
        },
        {
          value: 100,
          label: '100',
        },
      ],
    };
  }

  // (12-2025-Tracking-Cors)
  // componentDidMount() {
    // const { dispatch } = this.props;

    // dispatch(getCustomerCompanyList());
  // }

  _changePage = currentPage => {
    const { dispatch } = this.props;
    dispatch(changeFilters({ currentPage }));
    window.scrollTo(0, 0);
    dispatch(getNFList());
  };

  _reloadPage = currentPage => {
    const { dispatch } = this.props;
    dispatch(changeFilters({ currentPage }));
    dispatch(getNFList());
  };

  _changePageLimit = pageLimit => {
    const { dispatch } = this.props;
    dispatch(changeFilters({ currentPage: 1, pageLimit }));
    dispatch(getNFList());
  };

  _handleClearSearchButton = () => {
    const { dispatch } = this.props;
    dispatch(filtersClear());
    dispatch(changeSearchFieldIsInUse(false));
    dispatch(getNFList());
  };

  _renderFilterChip = () => {
    const { filters } = this.props;

    const chipItems = Object.entries(filters).map(filterItem => {
      const filterNameIndex = 0;
      const filterValueIndex = 1;

      if (
        filterItem[filterNameIndex] === FILTERS_NOT_USED_BY_THE_CHIP.INITIAL_PERIOD ||
        filterItem[filterNameIndex] === FILTERS_NOT_USED_BY_THE_CHIP.FINAL_PERIOD ||
        filterItem[filterNameIndex] === FILTERS_NOT_USED_BY_THE_CHIP.CURRENT_PAGE ||
        filterItem[filterNameIndex] === FILTERS_NOT_USED_BY_THE_CHIP.PAGE_LIMIT ||
        filterItem[filterNameIndex] === FILTERS_NOT_USED_BY_THE_CHIP.QUERY ||
        filterItem[filterNameIndex] === FILTERS_NOT_USED_BY_THE_CHIP.BY_DATE
      ) {
        return null;
      }

      if (filterItem[filterValueIndex]?.length > 0) {
        return <ChipItem key={filterItem[filterNameIndex]} value={filterItem[filterNameIndex]} />;
      }

      return null;
    }).filter(Boolean);
    
    return chipItems;
  }

  render() {
    const {
      ui,
      nfList,
      onNFClick,
      currentPage,
      pageLimit,
      totalItems,
      openOccurence,
      openReceipt,
      allDeliveries,
      onNFConfirmationClick,
      searchFieldIsInUse,
    } = this.props;
    const { paginationOptions } = this.state;
   
    if (ui.error) {
      return (
        <EmptyStateContainer>
          <WarningImage src={NotFoundIcon} alt="Not found icon" />
          <Typography variant="body1">{ui.error}</Typography>
          <StyledButton onClick={() => window.location.reload()}>
            <Replay /> Recarregar
          </StyledButton>
        </EmptyStateContainer>
      );
    }

    if (nfList[0]) {
      const chipItems = this._renderFilterChip();

      return (
        <Wrapper>
          <NFList>
            {searchFieldIsInUse ? (
              <SearchResultContainer>
                <Typography variant="body1">Resultado da sua busca:</Typography>
                <ClearSearchButton onClick={this._handleClearSearchButton}>
                  Limpar busca
                </ClearSearchButton>
              </SearchResultContainer>
            ) : chipItems.length > 0 ? (
              <SearchResultContainer>
                <Typography variant="body1">Resultado da sua busca:</Typography>
                <ChipContainer>{chipItems}</ChipContainer>
              </SearchResultContainer>) : null}
            {nfList.map((row, index) => {
              let hasPosition = false;
              allDeliveries.find(el => {
                if (el.nfId === row.id) {
                  hasPosition = true;
                }
              });

              return (
                <NewTrackingNFItem
                  key={Number(index)}
                  nfData={row}
                  reloadPage={() => this._reloadPage(currentPage)}
                  onClick={() => onNFClick(row)}
                  onConfirmClick={() => onNFConfirmationClick(row)}
                  openOccurence={openOccurence}
                  openReceipt={openReceipt}
                  hasPosition={hasPosition}
                />
              );
            })}
          </NFList>
          <Pagination
            options={paginationOptions}
            currentPage={currentPage}
            pageLimit={pageLimit}
            totalItems={totalItems}
            onChangePage={this._changePage}
            onPageLimitChange={this._changePageLimit}
          />
        </Wrapper>
      );
    }

    return (
      <EmptyStateContainer>
        <WarningImage src={WarningSecondaryIcon} alt="Warning icon" />
        <Typography variant="body1">
          Ops! Parece que não encontramos nenhuma nota para rastreio.
        </Typography>
        <StyledButton onClick={() => window.location.reload()}>
          <Replay /> Recarregar
        </StyledButton>
      </EmptyStateContainer>
    );
  }
}

function mapStateToProps(state) {
  return {
    nfList: state.tracking.nfList.data.list,
    totalItems: state.tracking.nfList.data.totalItems,
    currentPage: state.tracking.filters.currentPage,
    pageLimit: state.tracking.filters.pageLimit,
    ui: getNFListUI(state),
    allDeliveries: [
      ...state.dashboardRealTime.onTime.data,
      ...state.dashboardRealTime.lateRisk.data,
      ...state.dashboardRealTime.late.data,
      ...state.dashboardRealTime.onTimeWithJustification.data,
      ...state.dashboardRealTime.lateRiskWithJustification.data,
      ...state.dashboardRealTime.latedWithJustification.data,
      ...state.dashboardRealTime.lateWithoutJustification.data,
    ],
    searchFieldIsInUse: state.tracking.searchFieldIsInUse,
    filters: state.tracking.filters,
  };
}

export default connect(mapStateToProps)(TrackingNFList);
